import { useAppSelector } from "@/store/app/hooks";
import type { RootState } from "@/store/app/storeTypes";
import { useSelectedInputFieldRenderOverride } from "@/features/sparxsEditor/contexts/SelectedInputFieldRenderContext";

export const useSelectedInputField =
  (): RootState["editor"]["selectedInputField"] => {
    const selectedInputField = useAppSelector(
      (state) => state.editor.selectedInputField,
    );
    const renderOverride = useSelectedInputFieldRenderOverride();
    if (renderOverride?.data != null) {
      return renderOverride.data;
    }
    return selectedInputField;
  };
